import { createFileRoute } from '@tanstack/react-router';

import { V2ImportPage } from '@/features/v2-import';

/**
 * Temporary: the migration off ConsultNow V2. Superuser-only, and hidden from
 * the navigation for everyone else. Remove with the feature once V2 is gone.
 */
export const Route = createFileRoute('/_authenticated/import')({
  component: V2ImportPage,
  beforeLoad: () => ({
    breadcrumbs: [{ title: 'Import from ConsultNow', href: '/import' }],
  }),
});
